module.exports = __webpack_public_path__ + "img/热销商品1.e65aeed6.png";